import * as React from 'react';
import { StyledLoadingButton } from '../../../../../../../common/Styleguide/Common/Button';
import { createIframeUpdate } from '../helpers';
import { SubmissionContext } from '../../Context/SubmissionProvider';
import { updateSubmission } from '../../Mutations/update-submission-mutation';

type SubmissionNewBuildButtonProps = {
  createNewGameBuild: () => void;
};

const SubmissionNewBuildButton: React.FC<SubmissionNewBuildButtonProps> = ({ createNewGameBuild }) => {
  const { submission, gameBuild, baseForm, detailsForm, isNonEditable } = React.useContext(SubmissionContext);
  const [isSaving, setIsSaving] = React.useState(false);
  const isIframe = gameBuild?.loaderType === 'iframe';

  const onClick = async () => {
    if (isIframe) {
      await createIframeUpdate(submission!, baseForm!, detailsForm!, setIsSaving, updateSubmission);
    } else {
      createNewGameBuild();
    }
  };

  const label = isIframe ? 'Go to QA and notify admins of changes' : 'Submit new version';

  if (isNonEditable) {
    return null;
  }

  return (
    <StyledLoadingButton
      sx={{
        borderRadius: '8px',
        width: '100%',
      }}
      variant="contained"
      loading={isSaving}
      onClick={onClick}
    >
      {label}
    </StyledLoadingButton>
  );
};

export default SubmissionNewBuildButton;
